const ES = {
    dashboards: 'Dashboards',
    clients: 'Clientes',
    products: 'Productos',
    accounts: 'Cuentas',
    paymentLinks: 'Links de Pago',
    reports: 'Reportes',
    users: 'Usuarios',
    management: 'Gestión'
};

export default ES;
